export const environment = {
  production: true,
  environmentName: 'staging',
  chatAppOrigin: 'https://staging-coachyourself.ldscc.com', // Development chat app origin
};
